import type { LessonsStore } from './interfaces'

import { isReservedLesson } from '@composables/widgets/lessons/lessons'

export const getters = {
  isLoading: (state: LessonsStore): boolean => state.loading,
  getLessons: (state: LessonsStore): LessonsStore['lessons'] => state.lessons,
  hasLessons: (state: LessonsStore): boolean => state.lessons.length > 0,
  getMeta: (state: LessonsStore): LessonsStore['meta'] => state.meta,
  getFilters: (state: LessonsStore): LessonsStore['filters'] => state.filters,
  getCurrentPage: (state: LessonsStore): LessonsStore['currentPage'] => state.currentPage,
  getPerPage: (state: LessonsStore): LessonsStore['perPage'] => state.perPage,
  getSelectedIds: (state: LessonsStore): LessonsStore['selectedIds'] => state.selectedIds,
  hasSelection: (state: LessonsStore): boolean => state.selectedIds.length > 0,
  /** A reserved lesson among the ticked ones blocks the bulk delete, as in the legacy tab. */
  hasReservedSelected: (state: LessonsStore): boolean =>
    state.lessons.some(lesson => state.selectedIds.includes(lesson.id) && isReservedLesson(lesson.status)),
  getReservedLessons: (state: LessonsStore): LessonsStore['lessons'] =>
    state.lessons.filter(lesson => isReservedLesson(lesson.status)),
  getDeleteModal: (state: LessonsStore): LessonsStore['deleteModal'] => state.deleteModal,
  getActiveLesson: (state: LessonsStore): LessonsStore['activeLesson'] => state.activeLesson,
  isDeleting: (state: LessonsStore): boolean => state.deleting,
  getSlots: (state: LessonsStore): LessonsStore['slots'] => state.slots,
  getActionModal: (state: LessonsStore): LessonsStore['actionModal'] => state.actionModal,
  getActionLesson: (state: LessonsStore): LessonsStore['actionLesson'] => state.actionLesson,
  getRecurringPendingId: (state: LessonsStore): LessonsStore['recurringPendingId'] => state.recurringPendingId,
}
